import { Component } from '@angular/core';

import { PagePlaceholderComponent } from '../../../core/components/page-placeholder/page-placeholder.component';

@Component({
  selector: 'app-history',
  imports: [PagePlaceholderComponent],
  templateUrl: './history.component.html',
  styleUrl: './history.component.scss'
})
export class HistoryComponent {
  protected readonly icon = '🕰️';
  protected readonly pageTitle = 'pages.history.title';
  protected readonly subtitle = 'pages.history.subtitle';
}
